<template>
  <Card :pt="{ header: { class: 'tw-p-5' }, content: { class: '!tw-p-0' }, body: { class: '!tw-pt-0' } }">
    <template #header>
      <div class="space-y-1 tw-w-full tw-text-sm tw-font-normal">
        <label id="listbox-label" class="tw-block tw-leading-5 tw-text-black">
          <slot name="SelectLabel">Filter by service</slot>
        </label>

        <UiSingleSelectDropdown
          v-model="activeFilter.service"
          :items="filter.services"
          :primaryColor="$page.props.customisation.primary_background"
          @update:modelValue="updateFilters()"
        />
      </div>
    </template>

    <template #content>
      <div class="tw-inline-block tw-w-full tw-text-sm tw-font-normal">
        <label id="listbox-label" class="tw-mb-5 tw-block tw-py-1 tw-leading-5 tw-text-black">
          <slot name="SelectLabel">Filter by ratings</slot>
        </label>

        <FeedbackFilterRatings
          v-model="activeFilter.ratings"
          :ratings="filter.ratings"
          :totalReviews="totalReviews"
          @update:modelValue="updateFilters()"
        />
      </div>
    </template>

    <template #footer>
      <div class="tw-inline-block tw-w-full tw-text-sm tw-font-normal">
        <ToggleSwitchAlt
          v-model="activeFilter.commentsOnly"
          :color="$page.props.customisation.primary_background"
          @update:modelValue="updateFilters()"
        >
          <span class="tw-text-black">Detailed reviews only</span>
        </ToggleSwitchAlt>
      </div>
    </template>
  </Card>
</template>

<script setup>
import FeedbackFilterRatings from './FeedbackFilterRatings.vue';

const props = defineProps({
  filter: Object,
  totalReviews: Number,
  activeFilter: {
    service: [null, Number],
    ratings: Array,
    commentsOnly: Boolean,
  },
});

const emit = defineEmits(['valueSelect']);

const updateFilters = () => {
  emit('valueSelect', props.activeFilter);
};
</script>
